/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var /** @type {?} */ win = typeof window !== 'undefined' && window || /** @type {?} */ ({});
export { win as window };
//# sourceMappingURL=browser.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser/esm5/src/browser/tools/browser.js